import { MESSAGES_TYPES, SocketV2 } from '@/helper/socket'

const state = () => ({
  socket: null,
  isConnected: false,
  token: null,
});

const mutations = {
  SET_TOKEN: (state, token) => {
    /**
     * Устанавливает токен аутентификации
     * @param {Object} state - состояние хранилища
     * @param {string} token - токен аутентификации
     */
    state.token = token
  },
  SET_SOCKET (state, socket) {
    /**
     * Устанавливает экземпляр WebSocket
     * @param {Object} state - состояние хранилища
     * @param {SocketV2} socket - экземпляр WebSocket
     */
    state.socket = socket;
  },
  SET_IS_CONNECTED (state, value) {
    /**
     * Устанавливает статус подключения
     * @param {Object} state - состояние хранилища
     * @param {boolean} value - статус подключения
     */

    state.isConnected = value;
  },
  APPEND_HANDLER (state, { name, handler }) {
    /**
     * Добавляет обработчик сообщений WebSocket
     * @param {Object} state - состояние хранилища
     * @param {Object} payload - параметры обработчика
     * @param {string} payload.name - имя типа сообщения
     * @param {Function} payload.handler - функция-обработчик
     */
    state.socket.addHandler(name, handler)
  },
  REPLACE_HANDLERS (state, handlers) {
    /**
     * Заменяет все обработчики сообщений WebSocket
     * @param {Object} state - состояние хранилища
     * @param {Object} handlers - объект с обработчиками
     */
    state.socket.replaceHandlers(handlers)
  },
};

const actions = {
  init ({ commit, dispatch, getters }, { url = null, handlers = null }) {
    /**
     * Инициализирует WebSocket соединение
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры инициализации
     * @param {string} params.url - URL WebSocket сервера
     * @param {Object} params.handlers - обработчики сообщений
     */
    const current_token = getters.token
    if (!getters.isInit) {
      const socket = new SocketV2({
        url, handlers
      })
      commit('SET_SOCKET', socket);
      socket.connect({}).then(({ getters }) => {
        commit('SET_IS_CONNECTED', true)
        socket.sendMessage(
          {
            type: MESSAGES_TYPES.AUTH,
            token: current_token
          }
        )
      }).catch(() => {
        commit('SET_IS_CONNECTED', false)
      })
    }
  },
  connect ({ getters, commit }, { url }) {
    /**
     * Подключается к WebSocket серверу
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры подключения
     * @param {string} params.url - URL WebSocket сервера
     */
    if (getters.isConnected) {
      getters.socket.disconnect()
    }
    getters.socket.connect({
      url
    }).catch(() => {
      commit('SET_IS_CONNECTED', false)
    })
  },
  disconnect ({ getters, commit }) {
    /**
     * Отключается от WebSocket сервера
     * @param {Object} context - контекст Vuex
     * @returns {Promise} промис завершения отключения
     */
    return new Promise(resolve => {
      if (getters.isConnected) {
        getters.socket.disconnectWithClearSocket(resolve)
      }
      commit('SET_IS_CONNECTED', false)
    })
  },
  setToken ({ getters, commit }, { token = null }) {
    /**
     * Устанавливает токен аутентификации для WebSocket
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры токена
     * @param {string} params.token - токен аутентификации
     */
    commit('SET_TOKEN', token)
  },
  sendMessages ({ getters }, { message }) {
    /**
     * Отправляет сообщение через WebSocket
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры сообщения
     * @param {Object} params.message - объект сообщения
     */
    getters.socket.sendMessage(message)
  }
};

const getters = {
  isConnected: (state) => state.socket && state.isConnected,
  isInit: (state) => state.socket !== null,
  socket: (state) => state.socket,
  handlers: state => state.socket.handlers,
  token: (state) => state.token,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
